<div class="relative-div">
    @if (loading()) {
    <div class="spinner-overlay">
        <mat-spinner></mat-spinner>
    </div>
    }

    @if (event.headerText) {
    <h3>{{event.headerText.title}}</h3>
    <div [innerHTML]="event.headerText.body"></div>
    } @else if (event.pageTitle) {
    <h3>{{event.pageTitle}}</h3>
    }

    <form [formGroup]="registrationFormGroup">
        <!-- honeypot: hidden from humans, filled by bots -->
        <input type="text" name="hp_field" [(ngModel)]="hpField" [ngModelOptions]="{standalone: true}"
            autocomplete="off" tabindex="-1" aria-hidden="true"
            style="position:absolute;left:-9999px;top:-9999px;width:1px;height:1px;overflow:hidden" />
        <mat-card style="margin: 10px 0px">
            <mat-card-header>
                <mat-card-title>Name and affiliation</mat-card-title></mat-card-header>
            <mat-card-content>
                <div class="r-flex-column">
                    <div class="r-flex-column" formGroupName="firstAttendee">
                        <mat-form-field class="r-field r-inputfield ">
                            <mat-label>First name</mat-label>
                            <input matInput size="100" class="r-custom-input-background" placeholder="First name"
                                formControlName="firstName">
                            @if(registrationFormGroup.controls.firstAttendee.controls.firstName.hasError('required')) {
                            <mat-error>This field is required.</mat-error>
                            }
                        </mat-form-field>
                        <mat-form-field class="r-field r-inputfield">
                            <mat-label>Last name</mat-label>
                            <input matInput placeholder="Last name" formControlName="lastName">
                            @if(registrationFormGroup.controls.firstAttendee.controls.lastName.hasError('required')) {
                            <mat-error>This field is required.</mat-error>
                            }
                        </mat-form-field>
                        <mat-form-field class="r-field r-inputfield">
                            <mat-label>Email address</mat-label>
                            <input matInput type="email" placeholder="Email" formControlName="email">
                            @if(registrationFormGroup.controls.firstAttendee.controls.email.hasError('required')) {
                            <mat-error>This field is required.</mat-error>
                            }
                            @if(registrationFormGroup.controls.firstAttendee.controls.email.hasError('email')) {
                            <mat-error>The email is invalid.</mat-error>
                            }
                        </mat-form-field>
                    </div>
                    <div>
                        <mat-form-field class="r-field r-longinputfield">
                            <mat-label>Organisation</mat-label>
                            <input matInput placeholder="Organisation" formControlName="organisation">
                            @if(registrationFormGroup.controls.organisation.hasError('required')) {
                            <mat-error>This field is required.</mat-error>
                            }
                        </mat-form-field>
                    </div>
                    <div formGroupName="firstAttendee">
                        <mat-form-field class="r-field r-inputfield">
                            <mat-label>Job title</mat-label>
                            <input matInput placeholder="Job title" formControlName="jobTitle">
                            @if(registrationFormGroup.controls.firstAttendee.controls.jobTitle.hasError('required')) {
                            <mat-error>This field is required.</mat-error>
                            }
                        </mat-form-field>
                    </div>
                </div>
                <div [formGroup]="registrationFormGroup.controls.firstAttendee.controls.preferences"
                    style="margin-top: 15px; margin-left: 10px;">
                    @for (group of event.optionGroups; track group.id) {
                    <app-option-group [group]="group" formControlName="{{ group.id }}">
                    </app-option-group>
                    @let pref = registrationFormGroup.controls.firstAttendee.controls.preferences.controls[group.id];

                    @if (pref.invalid && pref.touched) {
                    @if (pref.hasError('exclusiveRequired')) {
                    <mat-error style="font-size: 12px">You must select one option.</mat-error>
                    }
                    @if (pref.hasError('minAnswersRequired')) {
                    <mat-error style="font-size: 12px">Please select at least {{group.minAnswers}} {{group.minAnswers
                        === 1 ? 'option' : 'options'}}.</mat-error>
                    }
                    @if (pref.hasError('maxAnswersRequired')) {
                    <mat-error style="font-size: 12px">Please do not select more than {{group.max}} {{group.minAnswers
                        === 1 ? 'option' : 'options'}}.</mat-error>
                    }
                    }
                    }
                </div>
            </mat-card-content>
        </mat-card>

        @if (event.allowMultipleRegistrations) {
        <mat-card style="margin: 10px 0px">
            <mat-card-header><mat-card-title>Additional participants</mat-card-title></mat-card-header>
            <mat-card-content>
                <p>If you need to register additional persons from your organisation, feel free to add their details
                    here. {{!event.freeEvent? 'The same rate applies to all included participants' : ''}}</p>
                <div id="additionalAttendees" formArrayName="additionalAttendees">
                    @for (attendee of additionalAttendeesFormArray.controls; let i = $index; track attendee) {
                    <div [formGroupName]="i" class="attendee-row">
                        <mat-list>
                            <div style="display: flex; flex-direction: row; align-items: baseline;">
                                <mat-form-field class="r-field r-inputfield">
                                    <mat-label>First name</mat-label>
                                    <input matInput size="10" placeholder="First name" formControlName="firstName"
                                        required>
                                    @if(additionalAttendeesFormArray.at(i).controls.firstName.hasError('required')) {
                                    <mat-error>This field is required.</mat-error>
                                    }
                                </mat-form-field>
                                <mat-form-field class="r-field r-inputfield">
                                    <mat-label>Last name</mat-label>
                                    <input matInput size="10" placeholder="Last name" formControlName="lastName"
                                        required>
                                    @if(additionalAttendeesFormArray.at(i).controls.lastName.hasError('required')) {
                                    <mat-error>This field is required.</mat-error>
                                    }
                                </mat-form-field>
                                <mat-form-field class="r-field r-inputfield">
                                    <mat-label>Email address</mat-label>
                                    <input matInput type="email" placeholder="Email" formControlName="email" required>
                                    @if(additionalAttendeesFormArray.at(i).controls.email.hasError('required')) {
                                    <mat-error>This field is required.</mat-error>
                                    }
                                    @if(additionalAttendeesFormArray.at(i).controls.email.hasError('email')) {
                                    <mat-error>This field is required.</mat-error>
                                    }
                                </mat-form-field>
                                <mat-form-field class="r-field r-inputfield">
                                    <mat-label>Job title</mat-label>
                                    <input matInput placeholder="Job title" formControlName="jobTitle">
                                    @if(additionalAttendeesFormArray.at(i).controls.jobTitle.hasError('required')) {
                                    <mat-error>This field is required.</mat-error>
                                    }
                                </mat-form-field>

                                <button mat-icon-button color="primary" (click)="deleteAttendee(i)">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </div>
                            <div [formGroup]="additionalAttendeesFormArray.at(i).controls.preferences"
                                style="margin-top: 15px; margin-left: 10px;">

                                @for (group of event.optionGroups; track group.id) {
                                <app-option-group [group]="group" formControlName="{{ group.id }}">
                                </app-option-group>
                                @let pref = additionalAttendeesFormArray.at(i).controls.preferences.controls[group.id];

                                @if (pref.invalid && pref.touched) {
                                @if (pref.hasError('exclusiveRequired')) {
                                <mat-error style="font-size: 12px">You must select one option.</mat-error>
                                }
                                @if (pref.hasError('minAnswersRequired')) {
                                <mat-error style="font-size: 12px">Please select at least {{group.minAnswers}}
                                    {{group.minAnswers
                                    === 1 ? 'option' : 'options'}}.</mat-error>
                                }
                                @if (pref.hasError('maxAnswersRequired')) {
                                <mat-error style="font-size: 12px">Please do not select more than {{group.max}}
                                    {{group.minAnswers
                                    === 1 ? 'option' : 'options'}}.</mat-error>
                                }
                                }
                                }
                            </div>
                        </mat-list>
                    </div>
                    }
                </div>

                <div style="display: flex; justify-content: center; margin-top: 20px;">
                    <button mat-raised-button color="primary" (click)="addAttendee()">Add participant</button>
                </div>
            </mat-card-content>
        </mat-card>
        }

        @for (d of event.disclaimers; track d.priority) {
        <div class="r-disclaimer">
            <p class="r-disclaimer-title">{{d.title}}</p>
            <div [innerHTML]="d.body"></div>
        </div>
        }

        @if (event.paymentConditions) {
        <mat-card style="margin: 10px 0px">
            <mat-card-header>
                <mat-card-title>{{event.paymentConditions.title}}</mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <div [innerHTML]="event.paymentConditions.body"></div>
            </mat-card-content>
        </mat-card>
        }

        <div class="r-button-row">
            <button matFab extended color="primary" (click)="register()">
                <mat-icon>how_to_reg</mat-icon>Submit
            </button>
        </div>
    </form>
</div>